import { Link, useNavigate } from 'react-router-dom'
import { useAuth } from '../context/AuthContext'
import { initials } from '../lib/auth'
import CustomerNav from './CustomerNav'

// App-shell for the connected client app.
//   - Header: logo left + avatar pill right (avatar goes to /account).
//   - Bottom nav (§5): Book / My orders / Account — 3 tabs.
//   - `hideNav` skips the bottom bar for standalone screens (e.g. an
//     order detail deep-linked from an email).
export default function Layout({ children, hideNav = false }) {
  const navigate = useNavigate()
  const { profile } = useAuth()
  const firstName = profile?.first_name || 'You'

  return (
    <div className="min-h-screen bg-white">
      <header className="sticky top-0 z-20 flex items-center justify-between border-b border-line bg-white/95 px-4 py-3 backdrop-blur">
        <Link to="/order" className="flex items-center gap-2" aria-label="Ghost Laundry — home">
          <img
            src="/logo-ghost.png"
            alt=""
            aria-hidden="true"
            width="36"
            height="36"
            className="h-9 w-9 rounded-md"
          />
          <img
            src="/logo-wordmark.png"
            alt="Ghost Laundry"
            height="24"
            className="h-6 w-auto"
          />
        </Link>

        <button
          type="button"
          onClick={() => navigate('/account')}
          className="flex items-center gap-1.5 rounded-full bg-[#F3F4F6] py-1 pl-1 pr-3 text-navy transition active:scale-95"
        >
          <div className="flex h-[26px] w-[26px] items-center justify-center rounded-full bg-navy text-[10px] font-extrabold text-white">
            {initials(profile)}
          </div>
          <span className="text-[12px] font-bold">{firstName}</span>
          <span className="text-[10px] text-ink-2">✏️</span>
        </button>
      </header>

      <main className={`mx-auto max-w-md ${hideNav ? '' : 'pb-16'}`}>{children}</main>

      {!hideNav && <CustomerNav />}
    </div>
  )
}
